export const GET_PLANS_LIST = "GET_PLANS_LIST";
export const SET_PLANS_LIST = "SET_PLANS_LIST";

export const GET_PLANS_BY_ID = "GET_PLANS_BY_ID";
export const SET_PLANS_BY_ID = "SET_PLANS_BY_ID";

export const GET_PLAN_TEMPLATE_BY_ID = "GET_PLAN_TEMPLATE_BY_ID";
export const SET_PLAN_TEMPLATE_BY_ID = "SET_PLAN_TEMPLATE_BY_ID";

export const ADD_PLANS = "ADD_PLANS";
export const ADD_PLANS_RESPONSE = "ADD_PLANS_RESPONSE";

export const UPDATE_PLANS = "UPDATE_PLANS";
export const UPDATE_PLANS_RESPONSE = "UPDATE_PLANS_RESPONSE";

export const DELETE_PLANS = "DELETE_PLANS";
export const DELETE_PLANS_RESPONSE = "DELETE_PLANS_RESPONSE";

export const GET_MODULES_AND_FEATURES_LIST = "GET_MODULES_AND_FEATURES_LIST";
export const SET_MODULES_AND_FEATURES_LIST = "SET_MODULES_AND_FEATURES_LIST";
